/* eslint no-param-reassign: 0 */

// Serial y bluetooth lo comparten bajo la clave 'setup_serial' para que
// Serial.begin() se emita una sola vez.
export const SERIAL_SETUP = 'Serial.begin(9600);';

// Separa las líneas pinMode que otro generador metió inline en un value input.
// Casi siempre es un no-op, pero se conserva para replicar la salida del legacy.
export const findPinMode = (dropdownPin) => {
  if (typeof dropdownPin === 'undefined') return { code: '', pin: '' };
  let code = '';
  let pin = dropdownPin;
  dropdownPin.split(';\n').forEach((line) => {
    if (line.search('pinMode') >= 0) {
      code += `${line};\n`;
    } else {
      pin = line;
    }
  });
  return { code, pin };
};
